import { Col, Form, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import { ReactComponent as SearchLocation } from "../../../image/SearchLocation.svg";
import "../../../styles/Main.scss";
import { ErrorNotificationMsg, SuccessNotificationMsg } from "../../../utils/Notifications";

const AddSectorModel = ({ handleCancel, setReload, sectorId, modalKey, setStateM }) => {
  const { t } = useTranslation();
  const formRef = useRef();

  // state initialisation
  const initialState = {
    sector_name: "",
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);

  // Fetch sector data by ID when `sectorId` or `modalKey` changes
  useEffect(() => {
    const sectorGetById = async () => {
      if (sectorId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`sectorname/${sectorId}/`);
          setState(response.data.data);
          formRef.current.setFieldsValue(response.data.data);
          setapiLoading(false);
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    sectorGetById();
  }, [sectorId, modalKey]);

  // Set up an event listener for the "Escape" key press to trigger the `backToList` function
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // function on Input Change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  // function to handle Cancellation and go back to SectorList form
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  // function for submission of form
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (sectorId === null) {
        response = await postRequest("sectorname/", state);
      } else {
        response = await patchRequest(`sectorname/${sectorId}/`, state);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          sectorId === null
            ? t("sector_name_added_successfully")
            : t("sector_name_updated_successfully")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1
        }));
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    }
    catch (error) {
      if (sectorId === null) {
        ErrorNotificationMsg(
          t("error_in_adding_sector_name")


        );
      }
      if (sectorId !== null && !error?.message) {
        ErrorNotificationMsg(
          t("error_in_updating_sector_name")


        );
      }


      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Col md={24} className="TextFeild">
            <InputField
              name="sector_name"
              label={t("sector_name")}
              placeholder={t("enter_sector_name")}
              handleInputChange={handleInputChange}
              prefix={<SearchLocation />}
              rules={t("pl_enter_sector_name")}
              pattern={"^[a-zA-Z_ ]+$"}
              max={20}
            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddSectorModel.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  sectorId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired
};

export default AddSectorModel;
